var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWmgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.91 21.347c-2.364.99-4.91-.18-5.91-2.432l-1.182-2.882c-.91-2.25.182-4.863 2.546-5.764 2.273-.992 4.91.18 5.818 2.43l1.182 2.883c.91 2.34-.182 4.863-2.455 5.764m-6.82 9.817c-2.27.99-4.908-.09-5.817-2.34l-5.364-12.79c-1-2.252.09-4.864 2.453-5.765 2.273-.992 4.91.09 5.82 2.34l5.363 12.79c.91 2.25-.182 4.863-2.455 5.764m-11.18 0c-2.274.9-4.91-.18-5.82-2.432l-5.362-12.7c-.91-2.34.18-4.952 2.454-5.854 2.273-.9 4.91.18 5.818 2.432l5.363 12.7c.91 2.252-.18 4.864-2.454 5.854m19.544-26.93C32.09-.177 24.91.002 21 .002 17.09 0 9.91-.177 5.456 4.236.82 8.828 0 12.97 0 19.545c0 6.936 1.09 11.08 5.455 15.402C9.272 38.64 16 39 21 39c5 0 11.728-.36 15.454-4.053C40.91 30.624 42 26.48 42 19.547c0-6.576-.818-10.72-5.546-15.312",
    fill: "#001247",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmgLogo);
export default __webpack_public_path__ + "static/media/wmg-logo.1eaf49bc.svg";
export { ForwardRef as ReactComponent };